import React, { Fragment, useState } from 'react';
import {
  Modal,
  Form,
  Row,
  Col,
  Container,
} from '@themesberg/react-bootstrap';
import { get } from '../../../services/back.service';
import ModalTriggerButton from '../../shared/ModalTriggerButton';

function ModalInfoSchedule({
  scheduleSelect,
  title,
  button_text,
  button_variant,
}) {
  const [show, setShow] = useState(false);
  const [infoForm, setForm] = useState({
    client: '',
    service: '',
    assigned_user: 0,
    schedule_date: '',
    schedule_hour: '',
    schedule_city: '',
    schedule_address: '',
    state: 'C',
    id_client: '',
    name_client: '',
    placa: '',
    vehicleclass: '',
    office: '',
    insurance: '',
    email: '',
    phone: '',
    observation: '',
  });

  const handleClose = () => setShow(false);

  const handleShow = async (idSchedule) => {
    const infoSchedule = await get('/schedule/' + idSchedule);
    if (infoSchedule.success) {
      const info = infoSchedule.data;
      setForm({ ...info });
    }
    setShow(true);
  };

  return (
    <Fragment>
      <ModalTriggerButton
        button_variant={button_variant}
        button_text={button_text}
        onClick={() => handleShow(scheduleSelect)}
      />

      <Modal animation={false} fullscreen="sm-down" show={show} onHide={handleClose}>
        <Modal.Header closeButton>
          <Modal.Title>{title}</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <Container>
            <Form >
              <Row>
                <Col>
                  <Form.Label htmlFor="id_client"> Cliente </Form.Label>
                  <Form.Control type="text" disabled readOnly value={infoForm.client_name} />
                </Col>
              </Row>
              <Row>
                <Col>
                  <Form.Label htmlFor="email">Correo Electronico</Form.Label>
                  <Form.Control type="text" disabled readOnly value={infoForm.email} />
                </Col>
                <Col>
                  <Form.Label htmlFor="phone">Telefono</Form.Label>
                  <Form.Control type="text" disabled readOnly value={infoForm.phone} />
                </Col>
              </Row>
              <Row>
                <Col>
                  <Form.Label htmlFor="id_client">Servicio</Form.Label>
                  <Form.Control type="text" disabled readOnly value={infoForm.service_name} />
                </Col>
                <Col>
                  <Form.Label htmlFor="id_client">Tecnico</Form.Label>
                  <Form.Control type="text" disabled readOnly value={infoForm.assigned_user_name} />
                </Col>
              </Row>
              <Row>
                <Col>
                  <Form.Label htmlFor="nombre">Fecha</Form.Label>
                  <Form.Control type="text" disabled readOnly value={infoForm.schedule_date} />
                </Col>
                <Col>
                  <Form.Label htmlFor="nombre">Hora</Form.Label>
                  <Form.Control type="text" disabled readOnly value={infoForm.schedule_hour} />
                </Col>
              </Row>
              <Row>
                <Col>
                  <Form.Label htmlFor="email">Oficina</Form.Label>
                  <Form.Control type="text" disabled readOnly value={infoForm.office_name} />
                </Col>
                <Col>
                  <Form.Label htmlFor="email">Ciudad</Form.Label>
                  <Form.Control type="text" disabled readOnly value={infoForm.schedule_city} />
                </Col>
                <Col>
                  <Form.Label htmlFor="email">Direccion</Form.Label>
                  <Form.Control type="text" disabled readOnly value={infoForm.schedule_address} />
                </Col>
              </Row>
              <Row>
                <Col>
                  <Form.Label htmlFor="placa">Placa</Form.Label>
                  <Form.Control type="text" disabled readOnly value={infoForm.placa} />
                </Col>
                <Col>
                  <Form.Label htmlFor="office">Clase</Form.Label>
                  <Form.Control type="text" disabled readOnly value={infoForm.vehicleclass_name} />
                </Col>
                <Col>
                  <Form.Label htmlFor="insurance">Aseguradora</Form.Label>
                  <Form.Control type="text" disabled readOnly value={infoForm.insurance} />
                </Col>
              </Row>
              <Row>
                <Col>
                  <Form.Label htmlFor="observation">Observaciones Adicionales</Form.Label>
                  <Form.Control type="text" disabled readOnly value={infoForm.observation} />
                </Col>
              </Row>

              <Form.Label htmlFor="email">Estado</Form.Label>
              <Form.Select
                disabled readOnly
                name="state"
                value={infoForm.state}
                aria-label="Default select example"
              >
                <option value='C'> Creado </option>
                <option value='S'> Asignada </option>
                <option value='P'> Proceso </option>
                <option value='T'> Terminado </option>
                <option value='CA'> Cancelado </option>
              </Form.Select>
            </Form>
          </Container>
        </Modal.Body>
      </Modal>
    </Fragment>
  );
}

export default ModalInfoSchedule;
